export default "__VITE_ASSET__CowubtqJ__"